import { rangePresets } from '@gogame/intl-ts';

export const TAB_GROUPS = 'groups';
export const TAB_PAGES = 'pages';

export const SCOPE_GROUPS = 'groups';
export const SCOPE_PAGES = 'pages';

export const VIEW_MODE_DATATABLE = 'datatable';
export const VIEW_MODE_TILES = 'tiles';
export const FILTERS = 'filters';
export const TABLE_SETTINGS = 'tableSettings';

export const FILTER_CREATED = 'created';
export const FILTER_APPLICATIONS = 'applicationIds';
export const FILTER_DOMAINS = 'domains';
export const FILTER_LOCALES = 'localeIds';
export const FILTER_FLOWS = 'conversionPageFlows';
export const FILTER_NETWORKS = 'networkIds';
export const FILTER_PLATFORMS = 'platformIds';
export const FILTER_TAGS = 'tagIds';
export const FILTER_USED_IN_ADS = 'usedInAds';
export const FILTER_IS_NEW = 'groupStatus';

export const CREATED_PERIOD_PRESETS = [
  rangePresets.TODAY,
  rangePresets.YESTERDAY,
  rangePresets.DAY_BEFORE_YESTERDAY,
  rangePresets.THIS_WEEK,
  rangePresets.THIS_MONTH,
  rangePresets.THIS_MONTH_MINUS_1,
  rangePresets.THIS_YEAR,
  rangePresets.LAST_3_DAYS,
  rangePresets.LAST_7_DAYS,
  rangePresets.LAST_10_DAYS,
  rangePresets.LAST_14_DAYS,
  rangePresets.LAST_30_DAYS,
  rangePresets.LAST_90_DAYS,
  rangePresets.LAST_180_DAYS,
  rangePresets.LAST_360_DAYS,
  rangePresets.LAST_MONTH,
  rangePresets.LAST_2_MONTHS,
  rangePresets.LAST_3_MONTHS,
  rangePresets.LAST_YEAR,
  rangePresets.LAST_12_MONTHS,
  rangePresets.LAST_12_MONTHS_PLUS_TODAY,
  rangePresets.LIFETIME,
  rangePresets.LIFETIME_PLUS_FUTURE,
];
